import React, { useState, useEffect } from "react"
import { useNavigate, useLocation } from 'react-router-dom'
import NotificationHandler from "../../utils/NotificationHandler"
import { enumUtil } from "../../utils/Enum"
import { ServerRequestProtected } from "../../utils/ServerDataRequest"
import Loader from "../shared/Loader/Loader"
import { useSelector } from "react-redux"

const CheckEmail = () => {
    const [isLoading, setIsLoading] = useState(false)
    const Email = useLocation().state;
    let navigate = useNavigate()
    const year = new Date().getFullYear();
    const API_URL = enumUtil.controller.Login

    const handleResendEmail = (Email) => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/ForgotPassword", 'post',
            {
                ...Email
            }
        ).then((response) => {
            setIsLoading(false)
            NotificationHandler('Email Sent Successfully', enumUtil.enumtoaster.success)
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler('Failed to Resend', enumUtil.enumtoaster.error)
        })
    }
    const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    return (
        <>
            {isLoading ? <Loader /> : null}
            {/* <div className="login">
                <div className="d-lg-flex half">
                    <div className="bg order-1 order-md-2">
                        <img src={process.env.PUBLIC_URL + "/assets/images/v2LoginHMS.jpg"} alt="" />
                    </div>
                    <div className="contents order-2 order-md-1">
                        <h1 className="hk-title">Employee Management System</h1>
                        <div className="container hk-form-t">
                            <div className="row align-items-start justify-content-center">
                                <div className="col-md-8 d-flex flex-column justify-content-center text-center">
                                    <div className="hk-t-img">
                                        <img src={process.env.PUBLIC_URL + "/assets/images/confirm-icon.svg"} alt="confirm email icon" />
                                    </div>
                                    <h2 class="heading xl text-center">Check your email</h2>
                                    <p className="text clr-muted text-center mt-3 forget-p">Reset password link has been sent to your email.</p>
                                    <a className="btn rounded btn-blue w-100 mt-4 reset-pass-btn mt-5" href="https://gmail.com" target="_blank" rel="noreferrer">
                                        Open email app </a>
                                    <p className="text text-center fw-semibold mt-5">Didn’t receive the email? <a className="hk-link" onClick={() => handleResendEmail(Email)}>Click to resend</a></p>
                                    <a className="text text-center inst-txt mt-4 text-decoration-none" onClick={() => navigate("../", { replace: true })}><span class="icon-Icon-ionic-md-arrow-round-back"></span> Back to Login</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="ar_login-screen">
                <div className="ar-main-screen-content w-100 d-flex align-items-center flex-column gap-25 justify-content-center">
                    <div className="login-content">
                        <div className="img-container h-auto s-70 mx-auto mb-15">
                            <img src={process.env.PUBLIC_URL + "/assets/images/confirm-icon.svg"} alt="confirm email icon" />
                        </div>
                        <div className="mb-3 pb-1 d-flex flex-column align-items-center">
                            <p className='fs-20 heading lh-normal'>Check your email</p>
                            <p className='text fs-11 color-muted lh-normal'>Reset password link has been sent to your email.</p>
                        </div>
                        <form autoComplete="on">
                            <div className="d-flex flex-column gap-20 br-bottom-1 za_br_light pb-4 mb-4">

                                <div className='position-relative login-btn-loader'>
                                    <a className="btn rounded btn-orange heading w-100 d-flex align-items-center justify-content-center" href="https://gmail.com" target="_blank" rel="noreferrer">Open email app </a>
                                </div>

                                <a className="text text-center inst-txt text-decoration-none" onClick={() => navigate("../", { replace: true })}><span class="icon-Icon-ionic-md-arrow-round-back fs-9"></span> Back to Login</a>
                            </div>

                            <div className="d-flex align-items-center justify-content-center">
                                <p className='text fs-12 color-95 '>©{year} {ThemeConfiguration?.configuration?.company?.name}. All rights reserved</p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}
export default CheckEmail
